<template>
  <div>
    <v-dialog
        v-model="dialog"
        persistent
        class="station-edit"
        max-width="1000"
        @close="$emit('close')"
    >
      <v-card v-if="station">
        <v-card-title>
          {{ station.stationId }} Station's Units
        </v-card-title>
        <div class="units-dialog-v-text-scrollable">
          <units-table
              ref="unitsTable"
              :station="station"
              @edit="editUnit"
              @delete="deleteUnit"
              @add="addUnit"
          />
        </div>
        <v-card-actions>
          <v-spacer/>
          <v-btn
              color="blue darken-1"
              text
              @click.native="dialog = false"
          >Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <edit-unit-popup
      ref="editUnitPopup"
      @saved="$refs.unitsTable.fetchData()"
    />
    <confirmation ref="confirmationPopup"/>
  </div>
</template>
<script>
import UnitsTable from '@/components/Neris/Units/UnitsTable';
import EditUnitPopup from '@/components/Neris/Units/EditUnitPopup';
import Confirmation from '@/components/Confirmation';
import neris from '@/api/neris';
import _ from 'lodash';

export default {
  name: 'UnitsListPopup',
  components: { Confirmation, EditUnitPopup, UnitsTable },
  data() {
    return {
      dialog: false,
      station: null,
    };
  },
  methods: {
    async show(station) {
      this.station = station;
      this.dialog = true;
      if (this.$refs.unitsTable) {
        this.$refs.unitsTable.resetItems();
      }
    },
    addUnit() {
      this.$refs.editUnitPopup.show(this.station);
    },
    editUnit(unit) {
      const unitData = _.cloneDeep(unit);
      this.$refs.editUnitPopup.show(this.station, unit.id, unitData);
    },
    deleteUnit(unit) {
      this.$refs.confirmationPopup.showConfirm(
        'Confirmation',
        'Are you sure you want to delete the unit?',
        async () => {
          await neris.deleteUnit(unit.id);
          await this.$refs.unitsTable.fetchData();
        },
      );
    },
  },
};
</script>
<style lang="scss">
.units-dialog-v-text-scrollable {
  max-height: calc(100vh - 155px);
  max-height: calc(100dvh - 155px);
  overflow-y: scroll
}
</style>
